import { render, staticRenderFns } from "./TableRiskAppraisal_5x4.vue?vue&type=template&id=559f936a&scoped=true"
import script from "./TableRiskAppraisal_5x4.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisal_5x4.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisal_5x4.vue?vue&type=style&index=0&id=559f936a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559f936a",
  null
  
)

export default component.exports